import ExpoAiLogo from 'pared/images/Expo/expoai.png'

import { IConfigsType } from '../../types'

const fwWingstopHome: IConfigsType = {
  'fw_wingstop-store-base-r3d9tnva': {
    '/:brand/home': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        fields: [
          'fwWingstopLossPrevention',
          'fwWingstopLocationGuest',
          'fwWingstopLocationWingyou',
        ],
      },
    },
  },
}

export default fwWingstopHome
